/*global translate*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Jsx from './poll_list_option.jsx'
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const worker = global.rootRequire('classes/globalUser')
// const workerContacts = global.rootRequire('classes/globalContacts')
const workerPolls = global.rootRequire('classes/globalPolls')
const {changePollsFunc,changeStatusTabmore,updateListPollState } = global.rootRequire('redux')
const {rxaget} = global.rootRequire('classes/ulti')
const chatDB = global.rootRequire('classes/indexedDB').default
class RxPollListOption_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      flagMorePoll:false,
      flagPollItem:false,
      pollInfo: rxaget(this.props, 'pollInfo', {}),
      user_answers_uin:[],
      group_id:this.props.group_id,
      listMember:{},
      group:this.props.group,
      poll_sender:{},
      currentMsg:rxaget(this.props, 'pollInfo.currentMsg', {}),
      
    }
  }
  componentDidMount(){
    this.fetchListMember()
    this.fetchPollList()
    // this.getPollById(this.state.pollInfo.poll_id)
    this.getUserAnswer()
  }
  showPollList(){
    this.props.updateListPollState(true)
    this.props.changeStatusTabmore(true)
    this.props.closePollPopup()
    this.setState({
      flagMorePoll:false,
      flagPollItem:false
    })
  }
  fetchPollList(){
    let group_id = this.state.group_id
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.props.token }
    fetch(global.rxu.get(global.rxu.config, 'api_poll_list')+'?group_id='+group_id, {
      method: 'GET',
      body: null,
      headers: headers 
    })
    .then((res) => { return res.json() })
    .then((json) => {
      if(json && json.polls){
        let pollsArr = [...json.polls]
        let objPolls = {
          group_id :group_id,
          data:pollsArr
        }
        chatDB.polls.put(objPolls, group_id)
        .catch(e => {
          console.log(e)
          alert(translate('There was an error when changing group, please logout and login into the app to use this feature'))
        })
        workerPolls.addPoll(group_id, {group_id:group_id,data: pollsArr})

        // this.setState({polls:json.polls})
        // console.log(json)
      }
    }).catch(er => console.log(er))
  }

  getUserAnswer(){
    let pollInfo = this.state.pollInfo//{...json}
    let answers = pollInfo.answers 
    let userid = this.props.userid
    let user_answers_uin = []
    pollInfo.currentMsg =  this.state.currentMsg
    for (let i = 0; i < answers.length; i++) {
      let user = answers[i].users.find(o => o.Id === userid);
      if(user){
        user_answers_uin.push(answers[i].id)
      } 
    }
    this.setState({user_answers_uin:user_answers_uin,pollInfo:pollInfo}) 
  }
  getPollById(poll_id){
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.props.token }
    fetch(global.rxu.get(global.rxu.config, 'api_get_poll')+poll_id, {
      method: 'GET',
      body: null,
      headers: headers 
    })
    .then((res) => { return res.json() })
    .then((json) => {
      let pollInfo = {...json}
      let answers = pollInfo.answers 
      let userid = this.props.userid
      let user_answers_uin = []

      pollInfo.currentMsg =  this.state.currentMsg
      for (let i = 0; i < answers.length; i++) {
        let user = answers[i].users.find(o => o.Id === userid);
        if(user){
          user_answers_uin.push(answers[i].id)
        } 
      }
      this.setState({user_answers_uin:user_answers_uin,pollInfo:pollInfo})
    }).catch(er => console.log(er))
  }
  async fetchListMember(){

    let occupants_uins = this.state.group.occupants_uins
    let sender_uin = rxaget(this.props, 'pollInfo.user_created.Id', '')

    let listMember = {} 
    let poll_sender = {}
    for (let i = 0; i < occupants_uins.length; i++) {
      let memberId = occupants_uins[i]
      let userInDB = await chatDB.users.get(Number(memberId))
      if (userInDB) {
        let member = {...userInDB}
        // let contactInDB = await workerContacts.contacts[userInDB.phone] 
        let contactInDB = await chatDB.contacts.get(userInDB.phone)
        member.group_fullname = (userInDB && contactInDB && contactInDB.name) ? contactInDB.name : (userInDB.name_display) ? userInDB.name_display : (userInDB.full_name) ? userInDB.full_name : (userInDB.phone) ? userInDB.phone : ''
        listMember[memberId]= member
        if(sender_uin.toString() === memberId.toString()){
          poll_sender = member
        }
      }
    }
    this.setState({listMember:listMember,poll_sender:poll_sender})
  }

  createPollAnswers(){
    let user_answers_uin = this.state.user_answers_uin
    let pollInfo = {...this.state.pollInfo}
    let group_id = this.state.group_id
    let userid = this.props.userid
    let ouser ={
      Id:this.props.userid
    }
    let isFirstVote = this.isFirstVote(pollInfo)
    if(pollInfo.status === 1){
      for (let i = 0; i < pollInfo.answers.length; i++) {
        let oanswer = pollInfo.answers[i]
        let isSelected = user_answers_uin.indexOf(oanswer.id) !== -1
        if(isSelected){
          let user = pollInfo.answers[i].users.find(o => o.Id === userid);     
          if(!user)  {
            pollInfo.answers[i].users.push(ouser)
          }
        }else{
          let users_new = oanswer.users.filter((o)=> { return o.Id !== userid });
          oanswer.users = users_new
        } 
      }
      let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.props.token }
  
      let params = {
          "group_id": group_id.toString(),
          "poll_id": pollInfo.poll_id,
          "user_answers": user_answers_uin
        }
      fetch(global.rxu.get(global.rxu.config, 'api_poll_user_answer'), {
        method: 'POST',
        body: JSON.stringify(params),
        headers: headers 
      })
      .then((res) => { return res.json() })
      .then((json) => {
        if(json && json.message && json.message === 'success'){
          let polls = workerPolls.polls[this.state.group_id]?.data
          let pollItem = polls.find(o => o.poll_id === pollInfo.poll_id);  
          pollItem.isFirstVote = isFirstVote
          this.updateUsersAnswer(user_answers_uin,pollItem)
        }
      }).catch(er => console.log(er))
    }

  }
  updateUsersAnswer(user_answers_uin,pollItem){
    let pollInfo = pollItem
    pollInfo.currentMsg =  this.state.currentMsg
    let answers = pollItem.answers
    let userid = this.props.userid
    let group_id = this.state.group_id
    let flagFoundUserid = false
    let userParams = {
      Id :userid,
      full_name:'',
      is_hide_searched:0,
      login:'',
      my_cloud_id:0

    }
    for (let i = 0; i < answers.length; i++) {
      let users = answers[i].users
      let user = users.find(o => o.Id === userid);
      if(user) flagFoundUserid = true
      if(user_answers_uin.indexOf(answers[i].id) !== -1 ){
        // let user = users.find(o => o.Id === userid);
        if(!user){
          answers[i].users.push(userParams)
          // answers[i].total_user_voted ++
        }
      }else{
        let users_new = users.filter((o)=> { return o.Id !== userid });
        // let user = users.find(o => o.Id === userid);
        if(user){
          answers[i].users = users_new
          // answers[i].total_user_voted --
        }
      }
    }

    pollInfo.answers = answers
    pollInfo.user_answers_uin = user_answers_uin
    if(!flagFoundUserid){
      pollInfo.total_user_voted ++
    }

    chatDB.polls.get({ group_id: group_id }).then(polls=>{
      let pollsArr = polls.data
      for (let i = 0; i < pollsArr.length; i++) {
        if(pollInfo.poll_id === pollsArr[i].poll_id){
          pollsArr[i] = pollInfo
        }
      }
      let params = {
        group_id:group_id,
        data:pollsArr,
      }
      chatDB.polls.put(params,group_id.toString()).then(rs=>{
        this.props.changePollsFunc()
      })
      this.props.createPollAnswers(pollInfo)
      this.setState({pollInfo:pollInfo})
      this.props.closePollPopup()
    })
  }
  onChooseAnswer(ele){
    let user_answers_uin = this.state.user_answers_uin
    let pollInfo = {...this.state.pollInfo}
    let answer_id = ele.id
    if(pollInfo.status === 1){
      if(user_answers_uin.indexOf(answer_id) === -1){
        user_answers_uin.push(answer_id)
      }else{
        user_answers_uin.splice(user_answers_uin.indexOf(answer_id),1)
      }
      this.setState({user_answers_uin:user_answers_uin})
    }
  }

  endVote(pollInfo){
    let group_id = this.state.group_id
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.props.token }
    let params = {
        "group_id": group_id.toString(),
        "poll_id": pollInfo.poll_id,
      }
    fetch(global.rxu.get(global.rxu.config, 'api_poll_end_vote'), {
      method: 'POST',
      body: JSON.stringify(params),
      headers: headers 
    })
    .then((res) => { return res.json() })
    .then((json) => {
      if(json && json.message && json.message === 'success'){
        pollInfo.status = 2
        this.setState({pollInfo:pollInfo})
      }
    }).catch(er => console.log(er))
  }
  chooseListMore(){
    let pollInfo = this.state.pollInfo
    // if(pollInfo.status === 1){
      this.setState({flagMorePoll:!this.state.flagMorePoll})
    // }
  }
  morepollChoose(value){
    let pollInfo = this.state.pollInfo
    // if(value==='finish-poll'){
    //   this.endVote(pollInfo)
    // }else{
    //   this.props.morepollChoose(value,pollInfo)
    // }
    this.props.morepollChoose(value,pollInfo)
    this.setState({flagMorePoll:false})
  }
  getTotalVote(ele){
    let userid = this.props.userid
    let users_new = ele.users//.filter((o)=> { return o.Id !== userid });
    let totalVote = users_new.length
    if(totalVote > 0){
      return totalVote.toString()
    } else if (ele.total_user_voted) {
      return ele.total_user_voted
    }
    return ''
  }

  checkPinMess() {
    var checkCode = 0
    try {
      const data = this.state.pollInfo 
      if ([5, 6].indexOf(data.type) === -1) {
        checkCode = 1
        for (const key in this.props.pinedMess) {
          const messages = this.props.pinedMess[key]
          messages.data.some(o => o.message_id === data.message_id) && (checkCode = 2)
        }
        return checkCode
      } else return checkCode

    } catch (error) {
      console.log("error", error)
      return checkCode
    }
  }

  isFirstVote(pollInfo){
    let isFirst = true
    let answers = pollInfo.answers 
    let userid = this.props.userid
    let user_answers_uin = []
    pollInfo.currentMsg =  this.state.currentMsg
    for (let i = 0; i < answers.length; i++) {
      let user = answers[i].users.find(o => o.Id === userid);
      if(user){
        return false
      } 
    }
    return isFirst
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  tabmore: state.tabmore,
})

const mapDispatchToProps = {
  changePollsFunc,
  changeStatusTabmore,
  updateListPollState
}

const RxPollListOption = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxPollListOption_)

export default RxPollListOption

